import { render, staticRenderFns } from "./BankOfferForm.vue?vue&type=template&id=c12ae0a0&"
import script from "./BankOfferForm.vue?vue&type=script&lang=js&"
export * from "./BankOfferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports